import { useCallback, useState } from "react";
import { STAUTES } from "../constant";

const usePageState = (defaultState = {}) => {
  const [pageState, setPageState] = useState({
    data: [],
    currentPage: 0,
    pageSize: 10,
    rowCount: 0,
    status: STAUTES.IDLE,
    sortModel: {},
    searchString: "",
    filterModel: { items: [] },  // Add filterModel to default state
    ...defaultState
  });

  const setStatus = useCallback(status => {
    setPageState(prevPageState => ({ ...prevPageState, status }));
  }, []);

  const setPagination = useCallback(({ page, pageSize }) => {
    setPageState(prevPageState => ({ ...prevPageState, currentPage: page, pageSize }));
  }, []);

  const setSortModel = useCallback(gridSortModel => {
    const selectedSort = gridSortModel[0];
    if (!selectedSort) return setPageState(prevPageState => ({ ...prevPageState, sortModel: {} }));
    const sortModel = {
      orderCol: selectedSort.field,
      orderByAscending: selectedSort.sort === "asc"
    };
    setPageState(prevPageState => ({ ...prevPageState, sortModel }));
  }, []);

  const setSearchString = useCallback(search => {
    const searchString = search.trim() === "" ? "" : search.replace(/\s{2,}/g, " ");
    setPageState(prevPageState => ({ 
      ...prevPageState, 
      searchString,
      currentPage: 0  // Reset to first page when search changes
    }));
  }, []);

  // New function to handle MUI DataGrid filter model changes
  const setFilterModel = useCallback((newFilterModel) => {
    setPageState(prevPageState => ({ 
      ...prevPageState, 
      filterModel: newFilterModel,
      currentPage: 0  // Reset to first page when filter changes
    }));
  }, []);

  return {
    ...pageState,
    setStatus,
    setPageState,
    setPagination,
    setSortModel,
    setSearchString,
    setFilterModel  // Export the new function
  };
};

export default usePageState;
